import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import type {WithdrawalPayload} from "./withdrawal.schema";

export interface WithdrawalApiPayload {
  amount: number;
  pm_account_id: string;
}

export interface WithdrawalResponse {
  data?: {
    status?: string;
    message?: string;
    reference?: string;
  };
  [key: string]: unknown;
}

export const withdrawalPagoMovilService = async (payload: WithdrawalPayload): Promise<WithdrawalResponse> => {
  return httpRequest<WithdrawalResponse, WithdrawalApiPayload>({
    method: "POST",
    url: "/user/pagomovil/withdrawal",
    baseUrl: config.walletApiUrl,
    body: {
      amount: payload.amount,
      pm_account_id: payload.pm_account_id,
    },
  });
};
